import(/* webpackMode: "eager" */ "/app/app/citizen/register/page.tsx");
